import type { SimpleChanges, TemplateRef } from '@angular/core';
import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Images } from './images';

export type IntegrationImage = keyof typeof Images;

@Component({
  selector: 'rti-svg-asset',
  templateUrl: './svg-asset.component.html',
  styleUrls: ['./svg-asset.component.less'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.horizontal-center]': 'centerHorizontally()',
  },
})
export class SvgAssetComponent {
  public readonly name = input<IntegrationImage>(undefined!);
  public readonly centerHorizontally = input(true, { transform: booleanAttribute });

  public assetPath: string;
  public template: TemplateRef<any>;

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.name) {
      this.updateAsset(this.name());
    }
  }

  private updateAsset(name: IntegrationImage) {
    const path = Images[name];
    if (!path) {
      // eslint-disable-next-line no-console
      console.info(`There is no image for ${name}`);
    }
    this.assetPath = `assets/integrations/images/${path}`;
  }
}
